import type { TypeBody } from '@/shared/api/generated/model';
import { pluralize } from '@/shared/lib/plural';

import { RECORDS, RECORDS_IN } from './kinds';

export interface Usage {
  records: number;
  published: number;
  used_in: { records: number }[] | null;
}

export function usageLine(type: TypeBody, usage: Usage): string {
  if (type.kind === 'block') {
    const records = (usage.used_in ?? []).reduce((sum, place) => sum + place.records, 0);

    return records === 0 ? 'пока нигде не стоит' : `стоит в ${pluralize(records, RECORDS_IN)}`;
  }

  if (usage.records === 0) {
    return 'записей пока нет';
  }

  return `${pluralize(usage.records, RECORDS)}, опубликовано ${String(usage.published)}`;
}
